import React, {useEffect, useState} from 'react';
import './onboard-question-style.scss';
import star from './images/question-star.svg';
import starNon from './images/question-star-non.svg';
import {useTranslation} from "react-i18next";

const QuestionStarComponent = (props) => {
    const {t} = useTranslation();
    const {select, error, value} = props;

    const [selectStar, setSelectStar] = useState(value || null);
    const [renderStars, setRenderStars] = useState([]);
    const [mError, setMError] = useState(false);

    const renderStar = () => {
        let result = [];
        for (let i = 0; i < 5; i++) {
            if (selectStar > i)
                result.push(<img className="cursor" key={i} alt="star" src={star} onClick={() => setSelectStar(i + 1)}/>);
            else
                result.push(<img className="cursor" key={i} alt="starNo" src={starNon} onClick={() => setSelectStar(i + 1)}/>);
        }
        setRenderStars(result);
    }

    useEffect(() => {
        if (error === true || selectStar === null) {
            setMError(true);
        }
    }, [error])

    useEffect(() => {
        setSelectStar(value);
    }, [value])

    useEffect(() => {
        renderStar();
        select(selectStar);
        setMError(false);
    }, [selectStar])

    return (
        <div>
            {mError && <p className="question-error">{t('feedback.error_empty')}</p>}
            <div className="question-star-root">
                {renderStars}
            </div>
        </div>
    )
};

export default QuestionStarComponent;
